import { useState, useRef } from 'react'
import { PaperAirplaneIcon, PaperClipIcon, XMarkIcon } from '@heroicons/react/24/outline'

import Spinner from './gsys-ui/Spinner/Spinner'
import { sendMessage } from '../lib/api'

const ComposeMessage = ({ enqId, refetchMessages }) => {
  const [isSending, setSending] = useState(null)
  const [messageText, setMessageText] = useState('')
  const [pickedImage, setPickedImage] = useState(false)
  const [error, setError] = useState(null)
  const pickerRef = useRef(null)

  const handlePressSend = async () => {
    if (!messageText && !pickedImage) return
    setSending(true)

    try {
      await sendMessage(enqId, messageText, pickedImage)
      setPickedImage(null)
      setMessageText('')
      await refetchMessages()
      setError(null)
    } catch (e) {
      setError('The message failed to send.')
    }

    setSending(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handlePressSend()
    }
  }

  const handlePressAttach = () => {
    pickerRef.current.click()
  }

  const handlePressRemoveAttach = () => {
    setPickedImage(false)
    pickerRef.current.value = ''
  }

  const handleChangeFile = (e) => {
    const file = e.target.files[0]
    const MAX_SIZE = 4 * 1024 * 1024
    console.log(file.size)

    if (file.size > MAX_SIZE) {
      setError('Images must be smaller than 4MB')
      return
    }

    setError(null)
    setPickedImage(file)
  }

  const handlePaste = (e) => {
    const items = e.clipboardData?.items
    if (!items) return

    for (const item of items) {
      if (item.type.indexOf('image') !== -1) {
        const file = item.getAsFile()
        setPickedImage(file)
        break
      }
    }
  }

  return (
    <div className="p-4 border-t border-white/10 bg-dark-900">
      {(pickedImage || error) && (
        <div className="flex justify-between items-center mb-3">
          <div className="text-error-500 text-sm font-medium">{error}</div>
          <div className="flex items-center">
            {pickedImage && (
              <>
                <img
                  className="object-cover w-12 h-12 rounded-mobile border border-white/20"
                  src={URL.createObjectURL(pickedImage)}
                  alt="picked image"
                />
                <XMarkIcon
                  className="ml-2 w-6 h-6 text-white/60 transition-colors cursor-pointer hover:text-white/80"
                  onClick={handlePressRemoveAttach}
                />
              </>
            )}
          </div>
        </div>
      )}
      <div className="flex items-center bg-dark-800/50 border border-white/20 rounded-mobile p-3 shadow-mobile">
        <div className="flex items-end flex-0">
          <input
            type="file"
            className="hidden"
            accept="image/*"
            ref={pickerRef}
            onChange={handleChangeFile}
          />
          <PaperClipIcon
            className="mr-3 w-6 h-6 text-white/60 transition-colors cursor-pointer hover:text-primary-500"
            onClick={handlePressAttach}
          />
        </div>
        <textarea
          value={messageText}
          onChange={(e) => setMessageText(e.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-1 outline-none resize-none bg-transparent text-white placeholder-white/50 font-medium"
          placeholder="Write a message..."
          rows={messageText.split('\n').length}
          onPaste={handlePaste}
          style={{
            minHeight: '24px',
            maxHeight: '120px',
            lineHeight: '1.5'
          }}
        />
        <div className="flex items-end flex-0">
          {isSending ? (
            <div className="mr-2">
              <Spinner size={20} />
            </div>
          ) : (
            <PaperAirplaneIcon
              className="ml-3 w-6 h-6 text-white/60 transition-colors cursor-pointer hover:text-primary-500"
              onClick={handlePressSend}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ComposeMessage
